import React from "react";
import { useWizard } from "react-use-wizard";
import withStyles from "isomorphic-style-loader/withStyles";
import StyledStepper, { StepItem } from "../../../../../toolkit/stepper";
import breadcrumbStyles from "../common/WizardBreadcrumb/styles.scss";
import styles from "./WizardStepper.scss";

interface WizardStepperProps {
  steps: StepItem[];
  onBack?: () => void;
  backLabel?: string;
  showBack?: boolean;
  canSelectStep?: (index: number) => boolean;
}

const WizardStepper: React.FC<WizardStepperProps> = ({
  steps,
  onBack,
  backLabel = "Back to Dashboard",
  showBack = false,
  canSelectStep,
}) => {
  const { activeStep, goToStep } = useWizard();

  const backAriaLabel = backLabel || "Back to dashboard";

  const backButton =
    showBack && onBack ? (
      <button
        type="button"
        onClick={onBack}
        className={breadcrumbStyles.backButton}
        aria-label={backAriaLabel}
      >
        <i className="fas fa-arrow-left" aria-hidden="true" />
      </button>
    ) : null;

  return (
    <div className={styles.wizardStepperBar}>
      <div className={styles.headerRow}>
        <div className={styles.backSlot}>{backButton}</div>
        <div className={styles.stepperWrap}>
          <StyledStepper
            steps={steps}
            activeStep={activeStep}
            onStepChange={index => {
              if (canSelectStep?.(index)) {
                goToStep(index);
              }
            }}
          />
        </div>
        <div className={styles.backSlot} aria-hidden={!!backButton}>
          {backButton ? (
            <span
              className={`${breadcrumbStyles.backButton} ${styles.backMirror}`}
            >
              <i className="fas fa-arrow-left" aria-hidden="true" />
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles, breadcrumbStyles)(WizardStepper);
